module.exports = __webpack_public_path__ + "media/assets/images/logos/binarysystem_logo-6e8fa1fb7bf9a8b79877d1650e3a5e58.png";